import Dashboard from "@/views/student/Dashboard";
import Profile from "@/views/student/Profile";
import PqSubscription from "@/views/student/PqSubscription";
import CourseCombination from "@/views/student/CourseCombination";

export default [
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "courses/combination",
    component: CourseCombination,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "profile",
    name: "Profile",
    component: Profile,
    meta: {
      requiresAuth: true
    }
  },
  // TODO- in updated version
  // {
  //   path: "courses",
  //   // component: Profile,
  //   meta: {
  //     requiresAuth: true
  //   }
  // },
  // {
  //   path: "subscriptions",
  //   // component: Profile,
  //   meta: {
  //     requiresAuth: true
  //   }
  // },
  // {
  //   path: "subscriptions/pq",
  //   // component: Profile,
  //   meta: {
  //     requiresAuth: true
  //   }
  // },
  {
    path: "subscriptions/pq/subscribe",
    component: PqSubscription,
    meta: {
      requiresAuth: true
    }
  }
];
